"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnFistName = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const ageType_1 = require("../../../../../../utils/ageType");
const classFunctions_1 = require("../../../../../../utils/classFunctions");
const Icon_1 = require("../../../../../Icon");
const Tooltip_1 = require("../../../../../Tooltip");
require("./index.scss");
const className = 'flight-passenger-list-first-name';
const AgeIcon = ({ age }) => {
    if (age && age < ageType_1.limitAges.infant) {
        return react_1.default.createElement(Icon_1.Icon, { name: 'nipple' });
    }
    else if (age && age < ageType_1.limitAges.child) {
        return react_1.default.createElement(Icon_1.Icon, { name: 'child' });
    }
    return null;
};
const ColumnFistName = () => {
    return {
        id: 'firstName',
        Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Passenger/List/Column/FirstName:Title', defaultMessage: 'First name' })),
        canSort: true,
        Cell: ({ row }) => {
            var _a;
            const { firstName, isAppeared } = row.original;
            const modificators = [
                ...isAppeared === true ? ['appeared'] : [],
                ...isAppeared === false ? ['not-appeared'] : [],
            ];
            const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
            return (react_1.default.createElement("span", { className: classNames },
                react_1.default.createElement("span", { className: `${className}__text` },
                    isAppeared === false && (react_1.default.createElement(Tooltip_1.Tooltip, { modificators: 'white', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Passenger/List/Column/LastName:NoShow', defaultMessage: 'No show' }) }, firstName)),
                    isAppeared !== false && (firstName)),
                react_1.default.createElement("span", { className: `${className}__icon` },
                    react_1.default.createElement(AgeIcon, { age: (_a = row.original.age) !== null && _a !== void 0 ? _a : null }))));
        },
    };
};
exports.ColumnFistName = ColumnFistName;
//# sourceMappingURL=index.js.map